/**
 * Help Center API Client
 *
 * Location: resources/react/src/api/help-api.js
 *
 * IMPORTANT: All API calls go to /api/help/* (not /help/*)
 */

/**
 * Get help center navigation
 *
 * @returns {Promise<{navigation: Array, featured_articles: Array}>}
 */
export const getHelpNavigation = async () => {
  const response = await fetch('/api/help', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch navigation');
  }

  return response.json();
};

/**
 * Get specific help article
 *
 * @param {string} category - Article category
 * @param {string} slug - Article slug
 * @returns {Promise<{title: string, description: string, html: string, toc: Array, updated_at: string}>}
 */
export const getHelpArticle = async (category, slug) => {
  const response = await fetch(`/api/help/${category}/${slug}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'include',
  });

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Article not found');
    }
    throw new Error('Failed to fetch article');
  }

  return response.json();
};

/**
 * Submit article feedback (was this helpful?)
 *
 * @param {string} category - Article category
 * @param {string} slug - Article slug
 * @param {boolean} helpful - Was the article helpful?
 * @param {string} [reason] - Optional free-text reason for feedback
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const submitHelpFeedback = async (
  category,
  slug,
  helpful,
  reason = ''
) => {
  // Why optional reason: lets users explain why article wasn't helpful — actionable feedback
  const body = { category, slug, helpful };
  if (reason) body.reason = reason;

  const response = await fetch('/api/help/feedback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error('Failed to submit feedback');
  }

  return response.json();
};
